<section class="title-container">
    <h2 class="title">
        {{ 'Reports.ContractScore.Title' | translate }}
    </h2>
    <hr class="separation-line" />
</section>

<section class="filters-container">
    <fieldset class="customers">
        <label class="label">
            {{'Reports.Filters.CustomerNumbers' | translate}}
        </label>
        <custom-multi-select [options]="customers$ | async" [searchEnabled]="userAssignedCustomersCount > 3"
            [(selectedKeys)]="selectedCustomers" [displayDetailedSelection]="true" [disabled]="userAssignedCustomersCount <= 1">
        </custom-multi-select>
    </fieldset>
    <fieldset>
        <label for="period" class="label">
            {{'Reports.Filters.Period' | translate}}
        </label>
        <custom-select name="period" [options]="periodOptions" [(selectedKey)]="selectedPeriod">
        </custom-select>
    </fieldset>

    <fieldset>
        <label for="claimType" class="label">
            {{'Reports.Filters.ClaimType' | translate}}
        </label>
        <custom-select name="claimType" [options]="keyValueClaimTypes" [(selectedKey)]="claimType">
        </custom-select>
    </fieldset>

    <button class="button-basic" (click)="onGenerateReport()">
        {{'Reports.Buttons.GenerateReport' | translate}}
    </button>
</section>

<section class="results-container" *ngIf="showResults">
    <iframe *ngIf="renderedReport" [src]="renderedReport" frameBorder="0" width="100%" height="750"></iframe>
</section>